import React from 'react';
import { compose } from 'redux';
import { withTutorialControl } from '../../store/tutorial';
import { withCancelNotification } from '../../store/dailytexts'
import Home from './';

class TutorialHome extends React.Component {

  componentDidMount() {
    this.props.start();
    this.props.cancelNotification();
  }

  render() {
    return <Home />
  }
}

export default compose(
  withCancelNotification,
  withTutorialControl
)(TutorialHome)



// WEBPACK FOOTER //
// ./src/routes/Home/TutorialHome.js